import React from "react";
import { Nav, Row, Col } from "react-bootstrap";
import { useSelector } from 'react-redux';
import { LoginMenu } from "../api-authorization/LoginMenu";
import AdminNavbarNotificationsContainer from "./AdminNavbarNotifications";
import { AdminNavbarUser } from "./AdminNavbarUser";
import { WithAuth } from "../Authorization/WithAuth";

const HeaderLinks = () => {
  const user = useSelector(state => state.authentication.user);

  return (
    <Row>
      <Col md={6} lg={6}>
      </Col>
      <Col md={6} lg={6}>
        <Nav pullRight>
          {
            user &&
            <WithAuth>
              <AdminNavbarNotificationsContainer />
            </WithAuth>
          }
          <LoginMenu />
          {
            user && <AdminNavbarUser user={user} />
          }
        </Nav>
      </Col>

    </Row>
  );
}
export default HeaderLinks;
